module.exports = __webpack_public_path__ + "static/media/ComputerTalk_Step1c_Image11.36236798.jpg";